import { gql } from '@/__generated__';

// Live snapshot of the broadcast-queue. Polled while a broadcast is sending so the
// /broadcast page can show sent / failed / pending progress and throughput.
export const broadcastQueueStatusDocument = gql(/* GraphQL */ `
  query BroadcastQueueStatus {
    broadcastQueueStatus {
      waiting
      active
      completed
      failed
      delayed
      paused
    }
  }
`);

// Failed recipients (within the retention window). The page filters these to the
// current send via failedAt >= sentAt.
export const broadcastFailedJobsDocument = gql(/* GraphQL */ `
  query BroadcastFailedJobs($limit: Int, $skip: Int) {
    broadcastFailedJobs(limit: $limit, skip: $skip) {
      id
      pageId
      name
      reason
      failedAt
    }
  }
`);
